<div class="mojo-input">
  <input
    #searchInput
    type="text"
    [placeholder]="placeholderText"
    [formControl]="searchControl"
  />
  <mat-icon
    class="prefix"
    *ngIf="prefixIcon"
    (click)="onPrefixClicked()"
  >{{ prefixIcon }}</mat-icon>
  <button
    mat-mini-fab
    *ngIf="suffixIcon"
    (click)="onSuffixClicked()"
    class="suffix"
    [ngClass]="{
            'social-mini': !mobile,
            'social-md': mobile
          }"
  >
    <mat-icon
      class="inherited"
      [ngClass]="{
                'large-icon': !mobile,
                'extra-large-icon': mobile
              }"
    >{{ suffixIcon }}</mat-icon>
  </button>
</div>
